import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, updateDoc } from 'firebase/firestore';

function EditRecord({ userId, record, onClose, onSuccess }) {
  const [date, setDate] = useState(record.date);
  const [height, setHeight] = useState(record.height.toString());
  const [weight, setWeight] = useState(record.weight.toString());
  const [memo, setMemo] = useState(record.memo || '');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!date || !height || !weight) {
      alert('모든 정보를 입력해주세요.');
      return;
    }

    if (parseFloat(height) <= 0 || parseFloat(weight) <= 0) {
      alert('올바른 수치를 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      await updateDoc(doc(db, 'users', userId, 'records', record.id), {
        date,
        height: parseFloat(height),
        weight: parseFloat(weight),
        memo: memo.trim() || '',
        updatedAt: new Date().toISOString()
      });

      alert('기록이 수정되었습니다!');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('기록 수정 실패:', error);
      alert('기록 수정에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <div className="fade-in" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div className="slide-up" style={{
        backgroundColor: 'white',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '400px',
        width: '100%',
        position: 'relative',
        maxHeight: '90vh',
        overflow: 'auto'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#8B7355'
          }}
        >
          ×
        </button>

        <div style={{
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>✏️</div>
          <h2 style={{
            color: '#E8A87C',
            fontSize: '24px',
            marginBottom: '8px'
          }}>
            기록 수정
          </h2>
          <p style={{
            color: '#8B7355',
            fontSize: '14px'
          }}>
            성장 기록을 수정하세요
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              측정 날짜
            </label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              max={today}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              키 (cm)
            </label>
            <input
              type="number"
              step="0.1"
              value={height}
              onChange={(e) => setHeight(e.target.value)}
              placeholder="예) 75.5"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              몸무게 (kg)
            </label>
            <input
              type="number"
              step="0.1"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              placeholder="예) 9.5"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
          </div>

          <div style={{ marginBottom: '32px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              메모 <span style={{ fontSize: '12px', color: '#D4956B', fontWeight: 'normal' }}>(선택사항)</span>
            </label>
            <textarea
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
              placeholder="예) 첫 이유식, 아팠음, 특이사항 등"
              maxLength={200}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box',
                minHeight: '80px',
                fontFamily: 'inherit',
                resize: 'vertical'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
            <div style={{
              textAlign: 'right',
              fontSize: '11px',
              color: '#8B7355',
              marginTop: '4px'
            }}>
              {memo.length}/200
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '12px'
          }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '16px',
                backgroundColor: 'white',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#8B7355',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#FAF3E8'}
              onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '16px',
                backgroundColor: loading ? '#D4956B' : '#E8A87C',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                if (!loading) e.target.style.backgroundColor = '#D4956B';
              }}
              onMouseOut={(e) => {
                if (!loading) e.target.style.backgroundColor = '#E8A87C';
              }}
            >
              {loading ? '수정 중...' : '수정하기'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditRecord;
